interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, description, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : ""}`}>
      <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.22em] text-accent-600">
        <span className="h-px w-6 bg-accent-400" />
        {eyebrow}
      </span>
      <h3 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px]">
        {title}
      </h3>
      <p
        className={`text-sm leading-relaxed text-foreground-600 md:text-[15px] ${
          isCenter ? "max-w-2xl" : "max-w-2xl"
        }`}
      >
        {description}
      </p>
    </div>
  );
}